(function () {
  var root = document.querySelector("[data-trio-picks]");
  if (!root) return;
  var form = root.closest("form");
  if (!form) return;
  var selects = Array.prototype.slice.call(root.querySelectorAll("[data-trio-soap]"));
  var help = root.querySelector("[data-trio-help]");
  var empty = root.querySelector("[data-trio-empty]");
  var addBtn = form.querySelector("[data-add]");
  var pay = form.querySelector(".chb-pdp-pay");
  var idInput = form.querySelector("[data-variant-id]");
  var error = form.querySelector("[data-product-error]");
  var qtyInput = form.querySelector(".qty");
  var map = null;
  var stock = {};
  var passing = false;
  var SOLD = "This soap is now sold out. Please choose another soap";

  function optionsOf(select) {
    return Array.prototype.filter.call(select.options, function (option) { return option.value; });
  }

  function soapByLabel(label) {
    if (!map) return null;
    for (var i = 0; i < map.soaps.length; i += 1) {
      if (map.soaps[i].label === label) return map.soaps[i];
    }
    return null;
  }

  function known(label) {
    return !!(stock[label] && stock[label].known);
  }

  function onSale(label) {
    if (!known(label)) {
      var option = optionsOf(selects[0]).filter(function (item) { return item.value === label; })[0];
      return !!(option && !option.disabled);
    }
    if (!stock[label].available) return false;
    if (stock[label].qty === null) return true;
    return stock[label].qty > 0;
  }

  function showSlot(select, show) {
    var note = select.parentElement.querySelector("[data-trio-slot-msg]");
    if (note) note.hidden = !show;
  }

  function paint() {
    var any = false;
    selects.forEach(function (select) {
      var chosen = select.value;
      optionsOf(select).forEach(function (option) {
        var sale = onSale(option.value);
        option.disabled = !sale;
        option.textContent = sale ? option.value : option.value + " \u2014 Sold out";
        if (sale) any = true;
      });
      if (chosen && known(chosen) && !onSale(chosen)) {
        select.value = "";
        showSlot(select, true);
      } else if (chosen && onSale(chosen)) {
        showSlot(select, false);
      }
    });
    if (empty) empty.hidden = any;
    if (help) help.hidden = !any;
    var labels = selects.map(function (select) { return select.value; });
    var ready = labels.every(Boolean) && labels.every(onSale);
    var parent = ready && map ? map.picks[labels.join("|")] : "";
    if (idInput) idInput.value = parent ? String(parent) : "";
    if (addBtn) {
      addBtn.disabled = !parent;
      addBtn.textContent = any ? "Add to basket" : "Sold out";
    }
    if (pay && !pay.hasAttribute("data-trade-hide-pay")) pay.hidden = !parent;
    if (help) help.hidden = !!parent || !any;
    return !!parent;
  }

  function setError(message) {
    if (error) error.textContent = message || "";
  }

  function loadMap() {
    if (map) return Promise.resolve(map);
    return fetch(root.getAttribute("data-trio-map"), { credentials: "same-origin" })
      .then(function (response) { if (!response.ok) throw new Error("map"); return response.json(); })
      .then(function (data) { map = data; return map; });
  }

  function refreshStock() {
    var handles = [];
    optionsOf(selects[0]).forEach(function (option) {
      handles.push({ label: option.value, handle: option.getAttribute("data-handle") });
    });
    if (map) {
      handles = map.soaps.map(function (soap) { return { label: soap.label, handle: soap.handle }; });
    }
    return Promise.all(handles.map(function (soap) {
      return fetch("/products/" + soap.handle + ".js", { credentials: "same-origin" })
        .then(function (response) { return response.json(); })
        .then(function (product) {
          var variant = (product.variants && product.variants[0]) || {};
          var qty = typeof variant.inventory_quantity === "number" ? variant.inventory_quantity : null;
          stock[soap.label] = {
            known: true,
            available: !!variant.available,
            qty: variant.available ? qty : 0,
            variantId: variant.id
          };
        });
    }));
  }

  function demandFor(extraQty) {
    var demand = {};
    function add(id, qty) {
      if (!id || qty <= 0) return;
      var key = String(id);
      demand[key] = (demand[key] || 0) + qty;
    }
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (item) {
          add(item.variant_id, item.quantity);
          var recipe = map && map.recipes[String(item.variant_id)];
          if (recipe) recipe.forEach(function (id) { add(id, item.quantity); });
          else add(item.variant_id, 0);
        });
        var counts = {};
        selects.forEach(function (select) {
          var soap = soapByLabel(select.value);
          if (!soap) return;
          counts[soap.variantId] = (counts[soap.variantId] || 0) + extraQty;
        });
        Object.keys(counts).forEach(function (id) { add(id, counts[id]); });
        return demand;
      });
  }

  function recheck() {
    setError("");
    return loadMap()
      .then(refreshStock)
      .then(function () {
        var lost = [];
        selects.forEach(function (select) {
          if (select.value && !onSale(select.value)) lost.push(select);
        });
        paint();
        if (lost.length) {
          lost.forEach(function (select) { showSlot(select, true); });
          setError(SOLD);
          if (lost[0]) lost[0].focus();
          return false;
        }
        if (!paint()) {
          setError(empty && !empty.hidden ? "These soaps are sold out." : "Choose three available soaps to add this box.");
          return false;
        }
        var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        return demandFor(qty).then(function (demand) {
          var short = null;
          map.soaps.forEach(function (soap) {
            var info = stock[soap.label];
            var needed = demand[String(soap.variantId)] || 0;
            if (info && info.qty !== null && needed > info.qty) short = soap.label;
          });
          if (short) {
            selects.forEach(function (select) {
              if (select.value === short) showSlot(select, true);
            });
            setError(onSale(short) ? "Not enough " + short + " is in stock for this box. Please choose another soap." : SOLD);
            paint();
            return false;
          }
          return true;
        });
      })
      .catch(function () {
        setError("We could not check soap stock. Please try again.");
        if (addBtn) addBtn.disabled = true;
        return false;
      });
  }

  selects.forEach(function (select) {
    select.addEventListener("change", function () {
      showSlot(select, false);
      setError("");
      paint();
    });
  });
  if (qtyInput) qtyInput.addEventListener("input", paint);

  form.addEventListener("submit", function (event) {
    if (passing) {
      passing = false;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    recheck().then(function (ok) {
      if (!ok) return;
      passing = true;
      if (form.requestSubmit) form.requestSubmit(addBtn);
      else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    });
  }, true);

  if (idInput) idInput.value = "";
  if (addBtn) addBtn.disabled = true;
  loadMap().then(refreshStock).then(paint).catch(function () {
    if (addBtn) addBtn.disabled = true;
  });
})();
